import { useTranslation } from "react-i18next";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import ConvertToString from "../../../../../components/Converter";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { DRUCKPFAHL, ZUGPFAHL } from "../../../../../constants";

const cnomFormulaDruck = `\\displaystyle P_{P} = F_{d} \\cdot \\gamma_{s} \\cdot \\xi_{1}`;
const cnomFormulaZug = `\\displaystyle P_{P} = F_{d} \\cdot \\gamma_{s,t} \\cdot \\xi_{1} \\cdot \\eta_{M}`;

export default function TestLoad({ value, loadDirection }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionTestLoads.testLoad")}</p>}
      indicesValue={
        <span>
          P<sub>P</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(value, 0)}</span>}
      unitValue={"kN"}
      formulaValue={
        <>
          <ToolTip
            id={"testLoadInfoDIN"}
            type={IconType.INFO}
            text={t("lvText.positionTestLoads.testLoadInfoDIN")}
          />
          <ToolTip
            id={"testLoadFormulaDIN"}
            type={IconType.FORMULA}
            formula={
              loadDirection === DRUCKPFAHL
                ? cnomFormulaDruck
                : loadDirection === ZUGPFAHL
                  ? cnomFormulaZug
                  : ""
            }
          />
        </>
      }
    />
  );
}
